interface MediaCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function MediaCheckbox({ checked, onChange }: MediaCheckboxProps) {
  return (
    <div className="filter-group mb-4">
      <label className="flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mr-2"
        />
        <span className="text-sm">仅显示含媒体的推文</span>
      </label>
    </div>
  );
}
